const moment = require('moment');

export function formatDateFromDate(date) {
  return moment(date).format('DD/MM/YYYY');
}

export function toMillisecondTimestamp(date) {
  return moment(date).valueOf();
}

export function today(format = 'DD/MM/YYYY') {
  return moment().format(format);
}
export function formatDateTime(timestamp) {
  var testDateUtc = moment.utc(timestamp);
  var localDate = moment(testDateUtc).local();
  return localDate.format('YYYY-MM-DD HH:mm:ss');
  //return moment.unix(timestamp).format("H:m:s, DD/MM/YYYY");
}

export function formatDate(timestamp, format = 'DD/MM/YYYY') {
  var testDateUtc = moment.utc(timestamp);
  var localDate = moment(testDateUtc).local();
  return localDate.format(format);
  //return moment.unix(timestamp).format("H:m:s, DD/MM/YYYY");
}

export function formatJSDate(date, format = 'DD/MM/YYYY') {
  var localDate = moment(date);
  return localDate.format(format);
  //return moment.unix(timestamp).format("H:m:s, DD/MM/YYYY");
}

export function formatDateUnix(timestamp, format = 'DD/MM/YYYY') {
  var testDateUtc = moment.unix(timestamp);
  var localDate = moment(testDateUtc).local();
  return localDate.format(format);
}

export function formatDateMonthUnix(timestamp) {
  var testDateUtc = moment.unix(timestamp);
  var localDate = moment(testDateUtc).local();
  return localDate.format('MM/YYYY');
}

export function formatDateTimeUnix(timestamp) {
  var testDateUtc = moment.unix(timestamp);
  var localDate = moment(testDateUtc).local();
  return localDate.format('DD/MM/YYYY HH:mm');
}

export function addDate(value = 1, from = false, format = 'M') {
  let currentDate = moment();
  if (from) {
    currentDate = moment.unix(from);
  }
  var futureMonth = moment(currentDate).add(value, format);
  var futureMonthEnd = moment(futureMonth).endOf('month');
  if (currentDate.date() != futureMonth.date() && futureMonth.isSame(futureMonthEnd.format('YYYY-MM-DD'))) {
    futureMonth = futureMonth.add(1, 'd');
  }
  return futureMonth.unix();
}

export function addDateTime(value = 1, from = false, format = 'M') {
  let currentDate = moment();
  if (from) {
    currentDate = moment.unix(from);
  }
  var futureMonth = moment(currentDate).add(value, format);
  var futureMonthEnd = moment(futureMonth).endOf('month');
  if (currentDate.date() != futureMonth.date() && futureMonth.isSame(futureMonthEnd.format('YYYY-MM-DD'))) {
    futureMonth = futureMonth.add(1, 'd');
  }
  return futureMonth.toDate();
}

export function currentUnix() {
  return moment().unix();
}

export function dateRange(startDate, endDate) {
  var start = moment(startDate);
  var end = moment(endDate);

  var result = [];

  if (end.isBefore(start)) {
    throw 'End date must be greated than start date.';
  }

  while (end > start || start.format('M') === end.format('M')) {
    result.push({
      text: start.format('MM/YYYY'),
      start: start.startOf('month').format('YYYY-MM-DD'),
      end: start.endOf('month').format('YYYY-MM-DD')
    });
    start.add(1, 'month');
  }

  return result;
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}
